import { render, staticRenderFns } from "./GithubArquivos.vue?vue&type=template&id=db4ac800&"
import script from "./GithubArquivos.vue?vue&type=script&lang=js&"
export * from "./GithubArquivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports